import { Label } from '@primer/react';
import { Link, Stack, VideoPlayer } from '@primer/react-brand';
import * as React from 'react';
export default {
  Label,
  Link,
  Stack,
  VideoPlayer,
  React
};